import React, { useEffect, useState } from "react";
import { apiGetFcsPaymentStatus } from "../../resource/index.js";
import MultiSelectBase from "../../components/searchBar/MultiSelectBase";
import Storage from "../../common/lib/storage";

/**
 * FCS 报表专用 PaymentStatus 组件。
 *
 * ⚠️ 跟 MT 共用的 ../PaymentStatus.js 区别:
 *   - 调 /api/fcs/payment-status(FCS 自己的 endpoint,状态机跟 hytech-payment Java 1:1)
 *   - 而 MT 的 PaymentStatus 调 /api/payment-status(从 DB 动态加载,可能跟 Java 端 drift)
 *
 * 为什么独立组件:MT 的 PaymentStatus 组件被多个 MT 报表页面引用,不能在 MT 端偷偷换 API。
 * 任何 FCS 报表的 PaymentStatus 用本组件,MT 报表的 PaymentStatus 继续用 MT 组件。
 */
const FcsPaymentStatus = ({
  id,
  value,
  dataType,
  onChange
}) => {
  const [paymentList, setPaymentList] = useState([]);
  const regulator = Storage.getRegulator() ?? "";

  useEffect(() => {
    if (dataType) {
      apiGetFcsPaymentStatus(regulator, dataType)
        .then((res) => {
          if (res.data.status === "success") {
            setPaymentList(res.data.data.paymentStatus.map(r => ({value: r.p_value, label: r.p_content})));
          }
        })
        .catch((e) => {
          setPaymentList([]);
        });
    } else {
      setPaymentList([]);
      onChange('');
    }
  }, [regulator, dataType]);

  return (
    <MultiSelectBase
      data={paymentList}
      onChange={(val) => onChange(val)}
      value={value}
      default_value="All Status"
      id={id}
      label="Payment Status"
    />
  );
};

export default FcsPaymentStatus;
